module.exports = new __parcel__URL__("kick_1.6d75be8e.mp3").toString();